import _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { getParameterByName } from '../../../Shared';
import { Question } from '../classroomLessons/interfaces';
import CustomizeNavbar from '../navbar/customizeNavbar';
import CustomizeEditionHeader from './customizeEditionHeader';
import Slide from './slide';

import {
  getClassLesson
} from '../../actions/classroomLesson';

import {
  getCurrentUserAndCoteachersFromLMS,
  getEditionMetadata,
  getEditionMetadataForUserIds,
  getEditionQuestions,
  publishEdition,
  setEditionMetadata,
  setEditionQuestions,
  setIncompleteQuestions,
  setOriginalEditionQuestions,
  setWorkingEditionMetadata,
  setWorkingEditionQuestions,
} from '../../actions/customize';

import {
  setEditionId,
  setTeacherModels,
  startListeningToSession,
} from '../../actions/classroomSessions';

import {
  getIncompleteQuestions,
  getStoredEditionMetadata,
  getStoredEditionQuestions,
  getStoredOriginalEditionQuestions,
} from '../../reducers/combined';

import {
  ClassroomSessionId,
  ClassroomUnitId
} from '../classroomLessons/interfaces';


class CustomizeEdition extends React.Component<any, any> {
  constructor(props) {
    super(props)

    const classroomUnitId: ClassroomUnitId|null = getParameterByName('classroom_unit_id')
    const activityUid = props.match.params.lessonID
    const classroomSessionId = classroomUnitId ? classroomUnitId.concat(activityUid) : null

    this.state = {
      classroomUnitId,
      classroomSessionId,
      timesSubmitted: 0,
    };


    props.dispatch(getCurrentUserAndCoteachersFromLMS())

    if (activityUid) {
      props.dispatch(getClassLesson(activityUid))
    }

    if (classroomSessionId) {
      props.dispatch(startListeningToSession(classroomSessionId))
    }


    this.updateQuestion = this.updateQuestion.bind(this)
    this.publish = this.publish.bind(this)
    this.resetSlide = this.resetSlide.bind(this)
    this.clearSlide = this.clearSlide.bind(this)
    this.updateName = this.updateName.bind(this)
    this.updateSampleQuestion = this.updateSampleQuestion.bind(this)
    this.clearName = this.clearName.bind(this)
    this.clearSampleQuestion = this.clearSampleQuestion.bind(this)
    this.afterPublishing = this.afterPublishing.bind(this)
  }

  componentDidMount() {
    const { classroomSessionId } = this.state
    const { dispatch, match, editionQuestions } = this.props
    const { lessonID, editionID } = match.params
    if (classroomSessionId) {
      setEditionId(classroomSessionId, editionID);
    }

    dispatch(getEditionMetadata(lessonID, editionID));
    dispatch(getEditionQuestions(editionID));
    dispatch(setOriginalEditionQuestions(editionQuestions));
  }

  componentDidUpdate(prevProps) {
    const { dispatch, editionMetadata, editionQuestions, customize, match } = this.props
    const { user_id, coteachers, editions } = customize
    const lessonID = match.params.lessonID

    const hasNewEdition = !_.isEqual(editionMetadata, prevProps.editionMetadata);
    const isEditionUndefined = prevProps.editionMetadata === undefined;
    const isMissingQuestions = !prevProps.editionQuestions.questions;

    if (hasNewEdition && isEditionUndefined) {
      dispatch(setEditionQuestions(editionQuestions));
      dispatch(setWorkingEditionQuestions(editionQuestions));
      dispatch(setWorkingEditionMetadata(editionMetadata));
    }

    if (hasNewEdition && isMissingQuestions) {
      dispatch(setEditionQuestions(editionQuestions));
      dispatch(setWorkingEditionQuestions(editionQuestions));
    }

    if (user_id) {
      if (user_id !== prevProps.customize.user_id || !_.isEqual(coteachers, prevProps.customize.coteachers)) {
        let user_ids:Array<Number>|never = []
        if (coteachers.length > 0) {
          user_ids = coteachers.map(c => Number(c.id))
        }
        user_ids.push(user_id)
        dispatch(getEditionMetadataForUserIds(user_ids, lessonID))
      }
    } else {
      if (Object.keys(editions).length === 0) {
        dispatch(getEditionMetadataForUserIds([], lessonID))
      }
    }
  }

  updateQuestion(question: Question, questionIndex: number) {
    const newEditionQuestions = _.merge({}, this.props.editionQuestions)
    newEditionQuestions.questions[questionIndex].data = question
    this.props.dispatch(setEditionQuestions(newEditionQuestions));
    this.props.dispatch(setWorkingEditionQuestions(newEditionQuestions));
  }

  setMetadataField(field: string, value: string) {
    const { dispatch, editionMetadata, customize, } = this.props
    const newEditionMetadata = _.merge({}, editionMetadata)
    newEditionMetadata[field] = value
    const newEditions = {...customize.editions}
    newEditions[newEditionMetadata.id] = newEditionMetadata
    dispatch(setEditionMetadata(newEditions));
    dispatch(setWorkingEditionMetadata(newEditions));
  }

  updateName(e) {
    this.setMetadataField('name', e.target.value)
  }

  updateSampleQuestion(e) {
    this.setMetadataField('sample_question', e.target.value)
  }

  clearName() {
    this.setMetadataField('name', '')
  }

  clearSampleQuestion() {
    this.setMetadataField('sample_question', '')
  }

  resetSlide(questionIndex: number) {
    const question = this.props.originalEditionQuestions.questions[questionIndex].data
    if (question) {
      question.reset = true
    }

    this.updateQuestion(question, questionIndex)
  }

  clearSlide(questionIndex: number) {
    const question = _.merge({}, this.props.editionQuestions.questions[questionIndex].data)
    const clearedSlide = {}
    Object.keys(question.play).map((k) => {
      if (k === 'cues') {
        clearedSlide[k] = ['']
      } else if (k === 'html') {
        clearedSlide[k] = '<p></p>'
      } else if (k === 'stepLabels') {
        const number = question.play[k].length
        clearedSlide[k] = []
        for (let i = 0; i < number; i+=1) {
          clearedSlide[k].push('')
        }
      } else if (typeof question.play[k] === 'string') {
        clearedSlide[k] = ''
      } else {
        clearedSlide[k] = question.play[k]
      }
    })
    question.play = clearedSlide
    question.teach.title = ''
    this.updateQuestion(question, questionIndex)
  }

  publish() {
    const slides = this.props.editionQuestions.questions.slice(1);
    const incompleteQuestions:Array<number>|never = [];

    slides.forEach((slide, i) => {
      let question = slide.data.play;
      let isIncomplete = (
        question.prompt === '' ||
          question.prompt &&
          question.prompt.trim() === '' ||
          question.prompt === '<p></p>' ||
          question.prompt == '<p><br></p>'
      ) || (
        !question.prompt &&
          question.html &&
          question.html === '<p></p>' ||
          question.html == '<p><br></p>'
      );

      if (isIncomplete) {
        incompleteQuestions.push(i);
      }
    });

    this.props.dispatch(setIncompleteQuestions(incompleteQuestions));

    this.setState(prevState => ({ timesSubmitted: prevState.timesSubmitted + 1 }))

    if (incompleteQuestions.length === 0 && this.props.editionMetadata.name) {
      this.props.dispatch(publishEdition(
        this.props.match.params.editionID,
        this.props.editionMetadata,
        this.props.editionQuestions,
        this.afterPublishing
      ));
    }
  }

  afterPublishing() {
    const classroomSessionId:ClassroomSessionId = this.state.classroomSessionId
    setTeacherModels(classroomSessionId, this.props.match.params.editionID)
    this.props.history.push(this.followUpLink())
  }

  followUpLink() {
    const {lessonID, editionID} = this.props.match.params
    const classroomUnitId = getParameterByName('classroom_unit_id')
    return classroomUnitId ? `/teach/class-lessons/${lessonID}?&classroom_unit_id=${classroomUnitId}` : `/teach/class-lessons/${lessonID}/preview/${editionID}`
  }

  handleBack = () => {
    if (window.history.length > 1) {
      this.props.history.goBack()
      return
    }
    const { lessonID } = this.props.match.params
    const classroomUnitId = getParameterByName('classroom_unit_id')
    const link = classroomUnitId ? `/customize/${lessonID}?&classroom_unit_id=${classroomUnitId}` : `/customize/${lessonID}`
    this.props.history.push(link)
  }

  renderFooter() {
    const { editionMetadata, incompleteQuestions, } = this.props
    const { timesSubmitted, } = this.state
    const hasIncompleteFields = timesSubmitted > 0 && (!editionMetadata.name || (incompleteQuestions && incompleteQuestions.length > 0))
    const helperText = hasIncompleteFields
      ? <p className="footer-error"><i className="fa fa-icon fa-exclamation-triangle" />You have left one of the fields above empty. Please fill out all the required fields and click Publish Edition.</p>
      : <p className="footer-helper-text">Press <span>“Publish Edition”</span> to save this lesson. You will see the <span>“Customized”</span> tag next to the name of the lesson.</p>
    return (
      <footer className="customize-edition-footer">
        <button className="quill-button medium outlined green focus-on-light" onClick={this.handleBack} type="button">Back</button>
        <div className="footer-right">
          {helperText}
          <button className="quill-button medium contained green focus-on-light" onClick={this.publish} type="button">Publish Edition</button>
        </div>
      </footer>
    )
  }

  renderSlides() {
    if (this.props.editionQuestions && this.props.editionQuestions.questions) {
      return this.props.editionQuestions.questions.slice(1).map((q, i) => this.renderSlide(q, i))
    }
  }

  renderSlide(q: Question, i: number) {
    const incompletePrompt = this.props.incompleteQuestions && this.props.incompleteQuestions.includes(i)
    return (
      <Slide
        clearSlide={this.clearSlide}
        incompletePrompt={incompletePrompt}
        key={i}
        question={q}
        questionIndex={i+1}
        resetSlide={this.resetSlide}
        updateQuestion={this.updateQuestion}
      />
    )
  }

  render() {
    const { editionMetadata, classroomLesson, } = this.props
    const { timesSubmitted, } = this.state

    if (!editionMetadata) { return <span /> }

    return (
      <div className="customize-edition-page">
        <CustomizeNavbar />
        <div className="customize-edition-container customize-page">
          <div className="customize-edition">
            <CustomizeEditionHeader
              clearName={this.clearName}
              clearSampleQuestion={this.clearSampleQuestion}
              editionName={editionMetadata.name}
              lessonNumber={classroomLesson.data.lesson}
              lessonTitle={classroomLesson.data.title}
              nameError={timesSubmitted > 0 && !editionMetadata.name ? 'Please enter a name for this edition.' : ''}
              sampleQuestion={editionMetadata.sample_question}
              timesSubmitted={timesSubmitted}
              updateName={this.updateName}
              updateSampleQuestion={this.updateSampleQuestion}
            />
            {this.renderSlides()}
          </div>
        </div>
        {this.renderFooter()}
      </div>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    customize: state.customize,
    classroomLesson: state.classroomLesson,
    incompleteQuestions: getIncompleteQuestions(state),
    originalEditionQuestions: getStoredOriginalEditionQuestions(state),
    editionMetadata: getStoredEditionMetadata(state, props),
    editionQuestions: getStoredEditionQuestions(state),
  }
}

function mergeProps(stateProps: Object, dispatchProps: Object, ownProps: Object) {
  return {...ownProps, ...stateProps, ...dispatchProps}
}

export default connect(mapStateToProps, dispatch => ({dispatch}), mergeProps)(CustomizeEdition)
